import React, { useState } from "react";
import Flag from "react-world-flags";
import { FiMenu, FiX } from "react-icons/fi";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLinks = [
    { href: "#daily", text: "Denní menu" },
    { href: "#menu", text: "Menu" },
    { href: "https://namaste.order.app.hd.digital/menus", text: "Online objednávka" },
    { href: "#gallery", text: "Galerie" },
    { href: "#contact", text: "Kontakt" },
  ];

  return (
    <nav className="bg-neutral-800 shadow-md sticky top-0 z-50 border-b border-red-800 text-white">
      <div className="max-w-6xl mx-auto px-4 py-4 flex justify-between items-center font-sans">
        {/* Logo a adresa */}
        <div className="flex items-center gap-3">
          <Flag code="IN" className="w-8 h-6 object-cover border rounded-sm" />
          <h1
            className="text-lg sm:text-xl font-extrabold tracking-wide text-orange-500"
            style={{
              textShadow: "1px 1px 2px #7f1d1d, -1px -1px 0px #7f1d1d",
            }}
          >
            Namaste Indicko nepálská restaurace
          </h1>
          <Flag code="NP" className="w-8 h-6 object-cover border rounded-sm" />
        </div>

        {/* Adresa */}
        <p className="hidden md:block text-sm text-gray-300">Máchova 6, Plzeň</p>

        {/* Navigace pro větší obrazovky */}
        <div className="hidden md:flex space-x-3">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="text-orange-400 hover:text-red-500 font-semibold text-sm tracking-wide transition px-3 py-1 rounded hover:bg-orange-900/20"
            >
              {link.text}
            </a>
          ))}
        </div>

        {/* Hamburger ikona pro mobily */}
        <div className="md:hidden">
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            className="text-orange-400 focus:outline-none"
          >
            {menuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Rozbalené menu na mobilech */}
      {menuOpen && (
        <div className="md:hidden px-4 pb-4 space-y-2 bg-neutral-900 text-sm">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="block text-orange-400 hover:text-red-500 font-semibold tracking-wide transition px-3 py-2 rounded hover:bg-orange-900/30"
            >
              {link.text}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
};

export default Navbar;